import ProductWidgetContainer from '../../../refresh/organism/ProductsLineUp/ProductWidgetContainer';
import React from 'react';

const WidgetUI = ({ widget, style }) => {
  const {
    position,
    component: { banners = [], componentName, heading, subHeading, platform, bgColor } = {}
  } = widget;

  return (
    <div
      id="widget"
      role="row"
      style={{
        ...style,
        width: '100%',
        paddingLeft: '2px',
        paddingRight: '2px',
        // outline: '1px solid red',
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <div role="gridcell" style={{ width: '100%' }}>
        <ProductWidgetContainer
          banners={banners[0]}
          componentName={componentName}
          heading={heading}
          subHeading={subHeading}
          bgColor={bgColor}
          rowNumber={position}
          platform={platform}
        />
      </div>
    </div>
  );
};
const arePropsEqual = (prevProps, nextProps) => {
    // Compare props deeply or with specific logic
    const prevFeedLogic = prevProps.widget?.component?.banners?.[0]?.feedLogic
    const nextFeedLogic =  nextProps.widget?.component?.banners?.[0]?.feedLogic
    const isSame  = prevFeedLogic === nextFeedLogic
    return isSame // Deep comparison
    
  };
  
export default React.memo(WidgetUI,arePropsEqual );

